export default __webpack_public_path__ + "static/media/portfolioUsingDjango.9a055785.webp";